function enquiry_styling() {
	const containers = document.querySelectorAll(
		".wp-block-c-blocks-enquiry-forms",
	);
	containers.forEach((container) => {
		const containerStyle = window.getComputedStyle(container);
		container.style.setProperty(
			"--main-background-color",
			containerStyle.backgroundColor,
		);
		container.style.setProperty("--main-text-color", containerStyle.color);
	});
}

window.addEventListener("load", function () {
	enquiry_styling();
});
